import { useWindowSize } from 'react-use';

const mediaQueries: any = {
	minWidth: (value: number, {width}: {width: number}) => width >= value,
	minHeight: (value: number, {height}: {height: number}) => height >= value,
	maxWidth: (value: number, {width}: {width: number, height?: number}) => width <= value,
	maxHeight: (value: number, {height}: {height: number}) => height <= value,
}

const withMediaQuery = (Component: any) => (props: any) => {
	const windowSize = useWindowSize();

	for ( const mediaQuery of Object.keys(mediaQueries) ) {
		if ( ! (mediaQuery in props) ) continue;
		if ( ! mediaQueries[mediaQuery](props[mediaQuery], windowSize) ) return null;
	}
	
	return Component(props);
}

export default withMediaQuery;